import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

import { getServerMessage } from '~/i18n/server-message.server.ts';
import ForgottenPasswordSchema from '~/modules/auth/forgotten-password-schema.ts';
import { sendResetPasswordLink } from '~/modules/auth/service.server.ts';

import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';

export interface ResetPasswordMutationResult {
	readonly formError?: string;
	readonly status: 'error' | 'ok';
}

export const sendResetPasswordLinkMutation = createServerFn({ method: 'POST' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.reset-password'],
			relatesTo: 'auth.send-reset-password-link',
		}),
	])
	.inputValidator(ForgottenPasswordSchema)
	.handler(async ({ data }) => {
		const { error } = await sendResetPasswordLink(data.email);

		if (error) {
			return {
				formError: getServerMessage(getRequest(), 'serverError.resetLink'),
				status: 'error',
			} satisfies ResetPasswordMutationResult;
		}

		return {
			status: 'ok',
		} satisfies ResetPasswordMutationResult;
	});
